import { createAction, props, union } from '@ngrx/store';
import { SharedAdviseLocationQueryI } from '../../api/shared-advise-location/shared-advise-location.query.int';
import { SharedAdviseLocationI } from '../../api/shared-advise-location/shared-advise-location.result.int';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';

export const error = createAction('[Shared / Advise Location] Error', props<{
    messageText: string;
    pageType: SharedPageTypeEnum;
}>());
export const load = createAction('[Shared / Advise Location] Get', props<{
    query: SharedAdviseLocationQueryI;
    pageType: SharedPageTypeEnum;
}>());
export const received = createAction('[Shared / Advise Location] Received', props<{
    result: SharedAdviseLocationI;
    pageType: SharedPageTypeEnum;
}>());
export const reset = createAction('[Shared / Advise Location] Reset', props<{
    pageType: SharedPageTypeEnum;
}>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
